import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { UserAssignmentViewQuickShareComponent } from "./user-assignment-view-quick-share.component";
import { TranslateModule } from "@ngx-translate/core";
import { ModalHeaderComponentModule } from "src/app/app/_component/modal-header/modal-header.module";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { DateTimePickerComponentModule } from "../../../date-time-picker/date-time-picker.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    ModalHeaderComponentModule,
    NgxMaterialTimepickerModule,
    DateTimePickerComponentModule,
  ],
  declarations: [UserAssignmentViewQuickShareComponent],
  exports: [UserAssignmentViewQuickShareComponent],
})
export class UserAssignmentViewQuickShareSpaceComponentModule {}
